<!-- live video -->
<div *ngIf="playLiveVideo" class="live-video-section tw-bg-[#000000] tw-mb-[4px]">
  <ng-container class="tw-relative">
    <ion-icon
      (click)="closeVideo()"
      *ngIf="liveVideoUrl"
      class="close-video tw-text-[#FFFFFF] tw-text-[30px] tw-absolute tw-right-[0px]"
      name="close-outline"
    >
    </ion-icon>
    <iframe *ngIf="liveVideoUrl"
      #streamVideo
      class="live-video"
      [src]="liveVideoUrl | sanitizer"
      width="100%"
      height="243px"
      frameborder="0"
      scrolling="no"
      allowfullscreen="true"
      allow="autoplay">
    </iframe>
  </ng-container>
</div>

<!-- races-info -->
<div *ngIf="!playLiveVideo" class="race-section">
  <p class="races-info" data-cy="races-info">

    <!-- selectedRace?.Current: {{ selectedRace?.Current }}
    currentSelectedFromEventStatus: {{ currentSelectedFromEventStatus }} -->

    <!-- Race status -->
    <span class="highlight" data-cy="race-status">
      <!-- {{
        selectedRace
          ? selectedRace?.Current
            ? currentSelectedFromEventStatus
            : (
                selectedRace?.RaceStatus
                | getRaceStatus: selectedRace?.PostTime: selectedEvent.eventName
                | countdown: false: selectedEvent.eventName | async
              )
          : (selectedEvent?.ToteResponse?.EventDetail?.EventStatus | getEventStatus)
      }} -->
      {{
        selectedRace
          ? (
              selectedRace?.RaceStatus
              | getRaceStatus: selectedRace?.PostTime: selectedEvent.eventName
              | countdown: false: selectedEvent.eventName | async
            )
          : (selectedEvent?.ToteResponse?.EventDetail?.EventStatus | getEventStatus)
      }}
    </span>

    <!-- Race number -->
    <span class="highlight" data-cy="race-number">
      {{
        selectedRace?.RaceId
          ? 'Race: '+selectedRace?.RaceId
          : ''
      }}
    </span>

    <!-- Event Track type -->
    <span data-cy="track-type">
      {{ selectedRace?.TrackType | getTrackType }}
    </span>

    <!-- Race type -->
    <span data-cy="race-type">
      {{ selectedRace?.RaceType }}
    </span>

    <!-- Race surface -->
    <span data-cy="race-surface">
      {{ selectedRace?.Surface }}
    </span>

    <!-- Race distance -->
    <span data-cy="race-distance">
      {{ selectedRace?.Distance }}
    </span>

    <!-- Race purse -->
    <span class="highlight" data-cy="race-purse">
      {{
        selectedRace?.Purse
          ? 'Purse: $' + (selectedRace?.Purse | numberWithCommas: 0)
          : ''
      }}
    </span>

  </p>
</div>

<!-- Closed race -->
<div *ngIf="(selectedRace?.RaceStatus | getRaceStatus) !== 'F'">
  <div
    *ngIf="
      selectedRace?.RaceStatus === 1
      || selectedRace?.RaceStatus === 2
      || selectedRace?.RaceStatus === 4
      || (selectedEvent?.ToteResponse?.EventDetail?.EventStatus === 'Closed')
    "
    class="tw-p-2 tw-bg-[#F7D82E] tw-text-sm close-race-section"
  >
    <p data-cy="closed-race-message">
      Sorry wagering is unavailable, this race is closed
    </p>
  </div>
</div>

<!-- Race selection -->
<div
  *ngIf="!playLiveVideo"
  class="
    race-selection-section
    races-paginate
    tw-relative
  "
>
  <div class="
    tw-flex
    tw-items-center
    tw-pr-[15px]
    tw-pl-[15px]
  ">
    <p
      class="tw-flex tw-inline tw-uppercase tw-font-bold tw-text-[13px] tw-mr-[11px]"
      data-cy="races-label"
    >
      races
    </p>
    <div #swipeRaceSectionTemplateRef class="current-races current-races-swipe" data-cy="race-numbers">
      <ng-container *ngIf="selectedRace !== undefined">
        <!-- [class.prev-paginate]="(selectedRace.RaceId || 0) > (race.RaceId || 0)" -->
        <span
          [class.prev-paginate]="race?.RaceStatus === 3"
          [class.active-paginate]="selectedRace?.RaceId === race?.RaceId"
          (click)="selectRace($event, race)"
          *ngFor="let race of (selectedEvent?.ToteResponse?.EventDetail?.Races)"
          [attr.data-cy]="'wager-race-number-' + race.RaceId"
        >
          {{ race?.RaceId }}
        </span>
      </ng-container>
    </div>
  </div>
  <p class="swipe-icon tw-flex">
    <ion-icon
      name="arrow-forward-outline"
      class="tw-text-[#3080EC] tw-text-[24px]">
    </ion-icon>
  </p>
</div>

<!-- Race is final -->
<div *ngIf="selectedRace?.RaceStatus === 3" class="tw-p-2 tw-text-sm">
  <!-- TODO: change the solution -->
  <ui-ion-race-final
    [cdRef]="cdRef"
    [router]="router"
    [permissionService]="permissionService"
    [selectedEvent]="selectedEvent"
    [raceId]="selectedRace?.RaceId || 0"
    [eventId]="selectedEvent.ToteResponse.EventDetail.EventId"
    [runId]="selectedEvent.ToteResponse.EventDetail.RunId"
  />
  <!-- <ui-ion-race-final
    [raceId]="selectedRace?.RaceId || 0"
    [eventId]="selectedEvent.ToteResponse.EventDetail.EventId"
    [runId]="selectedEvent.ToteResponse.EventDetail.RunId"
    [cdRef]="cdRef"
    [router]="router"
    [permissionService]="permissionService"
    [selectedEvent]="selectedEvent"
    [selectedRace]="selectedRace"
  /> -->
</div>

<!-- Race is not final -->
<div [hidden]="selectedRace?.RaceStatus === 3" class="races-pool-modify-swap-matrix">
  <div class="
    swipe-container
    tw-flex
    tw-items-center
  ">

    <!-- BET AMOUNT -->
    <p (click)="betAmount()" class="bet-amount tw-mr-[5px]" data-cy="bet-amount">
      <span class="tw-font-bold tw-text-[11px]">${{ baseAmount | formatAmount }}</span>
      <ion-icon name="chevron-down-outline"></ion-icon>
    </p>

    <!-- POOL -->
    <!-- [value]="selectedPool" -->
    <!-- value="WIN" -->
    <ion-select
      fill="outline"
      label-placement="stacked"
      interface="popover"
      [interfaceOptions]="{ cssClass: 'custom-popover' }"
      placeholder="POOL"
      toggleIcon="chevron-down-outline"
      expandedIcon="chevron-up-outline"
      class="tw-mr-[5px] ion-select"
      [(ngModel)]="pool"
      (ionChange)="selectPool($event)"
      data-cy="wager-pool-dropdown"
    >
      <!-- [value]="pool" -->
      <ion-select-option
        [value]="pool?.PoolName"
        *ngFor="let pool of selectedRace?.Pools"
        class="tw-uppercase"
      >
        {{ pool?.PoolName?.toUpperCase() }}
      </ion-select-option>
    </ion-select>

    <!-- MODIFIER -->
    <!-- value="Straight" -->
    <ion-select
      fill="outline"
      label-placement="stacked"
      interface="popover"
      [interfaceOptions]="{ cssClass: 'custom-popover' }"
      placeholder="MODIFIER"
      toggleIcon="chevron-down-outline"
      expandedIcon="chevron-up-outline"
      class="tw-mr-[5px] ion-select"
      (ionChange)="selectModifier($event)"
      [(ngModel)]="modifier"
      data-cy="wager-modifier-dropdown"
    >
      <ion-select-option *ngIf="selectedPool?.Straight" value="Straight">
        Straight
      </ion-select-option>
      <ion-select-option
        *ngIf="selectedPool?.Box && (((selectedPool?.PoolRaces||0) * (selectedPool?.Legs||0)) !== 1)"
        value="Box"
      >
        Box
      </ion-select-option>
      <ion-select-option *ngIf="selectedPool?.KeyBox" value="KeyBox">
        KeyBox
      </ion-select-option>
      <ion-select-option *ngIf="selectedPool?.PowerBox" value="PowerBox">
        PowerBox
      </ion-select-option>
      <ion-select-option *ngIf="selectedPool?.KeyWheel" value="KeyWheel">
        KeyWheel
      </ion-select-option>
      <!-- *ngIf="selectedPool?.Dutch"  -->
      <ion-select-option
        *ngIf="
          selectedEvent.ToteResponse.EventDetail.currentRace !== undefined
          && selectedEvent.ToteResponse.EventDetail.currentRace.RaceId === selectedRace.RaceId
          && selectedPool !== undefined
          && selectedPool.PoolId !== undefined
          && poolMatrix[selectedPool.PoolId]?.response?.ToteResponse !== undefined
          && poolMatrix[selectedPool.PoolId]?.response?.ToteResponse.Total !== 0
          && (
            selectedPool.PoolId === 'WIN' ||
            selectedPool.PoolId === 'EX' ||
            selectedPool.PoolId === 'DBL' ||
            selectedPool.PoolId === 'QU'
          )
        "
        value="DutchCost"
      >
        Dutch
      </ion-select-option>
      <ion-select-option
        *ngIf="(selectedPool?.Legs||0) * (selectedPool?.PoolRaces||0) > 1"
        value="ABC"
      >
        ABC
      </ion-select-option>
    </ion-select>

    <!-- SWAP -->
    <!-- <ion-button class="swap" (click)="hasPermission()" data-cy="wager-swap-button" disabled>
      SWAP
    </ion-button> -->

    <!-- MATRIX -->
    <ion-button class="matrix" (click)="openMatrix()" data-cy="wager-matrix-button">
      MATRIX
    </ion-button>
  </div>
</div>


<!-- Runner -->
<feature-ion-runner
  [events]="events"
  [selectedEvent]="selectedEvent"
  [selectedRace]="selectedRace"
  [isShowRunnners]="isShowRunnners"
  [selectedPool]="selectedPool"
  [selectedModifier]="selectedModifier"
  [setBaseAmount]="setBaseAmount"
  [dblPkArray]="dblPkArray"
  [triggerLiveVideo]="triggerLiveVideo"
  [poolMatrix]="poolMatrix"
>
